export default __webpack_public_path__ + "static/media/FinalProject.24a06bd9.jpg";